/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_Dashboard_TitleInputs */

const en_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic AD Import`)
};

const fr_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation automatique des annonces`)
};

const de_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer AD-Import`)
};

const it_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione automatica di AD`)
};

const ru_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический импорт рекламы`)
};

const es_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación automática de AD`)
};

const zh_cn2_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动 AD 导入`)
};

const ja_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動広告インポート`)
};

const hi_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित विज्ञापन आयात`)
};

const pt_pt2_ad_import_dashboard_title = /** @type {(inputs: Ad_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação automática de anúncios`)
};

/**
* | output |
* | --- |
* | "Automatic AD Import" |
*
* @param {Ad_Import_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_dashboard_title = /** @type {((inputs?: Ad_Import_Dashboard_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_Dashboard_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_import_dashboard_title(inputs)
	if (locale === "de") return de_ad_import_dashboard_title(inputs)
	if (locale === "it") return it_ad_import_dashboard_title(inputs)
	if (locale === "ru") return ru_ad_import_dashboard_title(inputs)
	if (locale === "es") return es_ad_import_dashboard_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_import_dashboard_title(inputs)
	if (locale === "ja") return ja_ad_import_dashboard_title(inputs)
	if (locale === "hi") return hi_ad_import_dashboard_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_import_dashboard_title(inputs)
	return en_ad_import_dashboard_title(inputs)
});